import React from 'react';
import { Input } from '../../../components/Form';
import { Text } from 'rebass';
import Button from '../../../components/Button/Button';
import { sendForgotPasswordEmail } from '../../../services/auth';
import { useHistory } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { RouteComponentProps, withRouter } from 'react-router';

/**
 * @component for forgot password form
 */
const ForgotPasswordForm: React.FC<RouteComponentProps> = ({ location }) => {
  const [email, setEmail] = React.useState(
    decodeURIComponent(
      location?.search?.replace(/[?&]email=(.+)&?/, '$1') ?? ''
    )
  );
  const [errorMessage, setErrorMessage] = React.useState('');
  const [showSentEmailMessage, setShowSentEmailMessage] = React.useState(false);

  const history = useHistory();

  // Handles when form is submitted
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await sendForgotPasswordEmail(email);
      setErrorMessage('');
      setShowSentEmailMessage(true);
    } catch (error: any) {
      setErrorMessage(error.message);
    }
  };

  // When input changes
  const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessage('');
    setEmail(e.target.value);
  };

  const handleReturnToLoginPageClick = (e: React.FormEvent) => {
    e.preventDefault();
    history.push('/login');
  };

  return (
    <AuthForm onSubmit={handleSubmit}>
      <Text variant="heading2" mt={4}>
        Forgot Password
      </Text>
      {showSentEmailMessage ? (
        <Text variant="body1a" mt={4}>
          Please check your email for instructions to reset your password.
        </Text>
      ) : (
        <Input
          id="input-email"
          type="email"
          placeholder="Email"
          mt={5}
          padding={5}
          name="email"
          value={email}
          onChange={handleEmailInputChange}
        />
      )}
      {errorMessage && (
        <Text variant="subheading" mt={2} sx={{ color: '#D9534F' }}>
          {errorMessage}
        </Text>
      )}
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Button
          mt={errorMessage ? 2 : 6}
          sx={{ visibility: showSentEmailMessage ? 'hidden' : '' }}
          type="submit"
          variant="primary"
        >
          Submit
        </Button>
        <Button mt={6} variant="outline" onClick={handleReturnToLoginPageClick}>
          Return to Login Page
        </Button>
      </div>
    </AuthForm>
  );
};

export default withRouter(ForgotPasswordForm);
